import { render, staticRenderFns } from "./new_index.vue?vue&type=template&id=595028f1&scoped=true&"
import script from "./new_index.vue?vue&type=script&lang=js&"
export * from "./new_index.vue?vue&type=script&lang=js&"
import style0 from "./new_index.vue?vue&type=style&index=0&id=595028f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595028f1",
  null
  
)

export default component.exports